
app.controller('BCAAgreementCtrl', function ($scope, $uibModalInstance, agreementNumber, $window, $q, $http) {

    $scope.agreementNumber = agreementNumber;
    $scope.accept = function () {
        $uibModalInstance.close('accept', $scope.agreementNumber);
    };
    
    $scope.Broker = '';


    var allPromise = $q.all([
        $http({
            method: 'POST',
            url: '/service/client.svc/retrieveSession',
        }).then(function (data) {
            if (!data.data.d) {
                $http({
                    method: 'GET',
                    url: '/service/client.svc/SignOut',
                }).then(function (data) {
                    if (data.data.d == true) {
                        $window.location.href = "#/login";
                        $window.location.reload();
                    }
                }, function (error) { })
            }
            else
                $scope.currentUser = data.data.d;
        }, function (error) { }),

       $http({
           method: 'GET',
           url: '/service/client.svc/getBrokerClient',
       }).then(function (data) {
           if (data.data.d) {
               $scope.Broker = data.data.d;
           }
       }, function (error) { }),
    ]);

    allPromise.then(function () {

    });


    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel', $scope.agreementNumber);
    };
});

